import React, { useState } from 'react';
interface IModalCommon {
    handleClose?: any;
    changeName: any;
}
const ChangeTicketName: React.FC<IModalCommon> = ({ handleClose, changeName }) => {
  const [ name, setName ] = useState('');

  const handleTypeName = (e: any) => {
    setName(e.target.value);
  };

  const handleNameChange = (e: any) => {
    changeName(name);
    handleClose();
  };


  return (
    <div className='audit-add-modal-cont'>
      <div className='audit-add-modal-cont-head'>
        <div className='audit-add-modal-head-cont-change'>
          <div className='audit-add-modal-head-cont-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'>
              <path d='M13.9092 7H6.10918C4.98907 7 4.42902 7 4.0012 7.21799C3.62487 7.40973 3.31891 7.71569 3.12717 8.09202C2.90918 8.51984 2.90918 9.0799 2.90918 10.2V13.8C2.90918 14.9201 2.90918 15.4802 3.12717 15.908C3.31891 16.2843 3.62487 16.5903 4.0012 16.782C4.42902 17 4.98907 17 6.10918 17H13.9092M17.9092 7H19.7092C20.8293 7 21.3893 7 21.8172 7.21799C22.1935 7.40973 22.4994 7.71569 22.6912 8.09202C22.9092 8.51984 22.9092 9.0799 22.9092 10.2V13.8C22.9092 14.9201 22.9092 15.4802 22.6912 15.908C22.4994 16.2843 22.1935 16.5903 21.8172 16.782C21.3893 17 20.8293 17 19.7092 17H17.9092M17.9092 21L17.9092 3M20.4092 3.00001L15.4092 3M20.4092 21L15.4092 21' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='audit-add-modal-head-cont-supporting'>
            <h1>Change ticket name</h1>
            <p>Enter the desired name for your search.</p>
          </div>
        </div>
        <div className='audit-add-modal-head-close' onClick={handleClose}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
      <div className='audit-add-modal-cont-body' style={{ paddingTop: '12px', paddingBottom: '12px' }}>
        <div className='audit-add-modal-cont-body-frame'>
          <div className='audit-add-modal-cont-body-frame-form'>
            <div className='audit-add-modal-cont-body-frame-form-row'>
              <div className='audit-add-modal-cont-body-frame-form-row-input'>
                <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                  <input className='audit-add-modal-cont-body-frame-form-input' type='text' placeholder='e.g. Oligarch Supply Chain Scan' value={name} onChange={(e) => {
                    handleTypeName(e);
                  }}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
      <div className='audit-modal-cont-footer'>
        <div className='audit-modal-cont-footer-content'>
          <div className='audit-modal-cont-footer-content-btn-cancel' onClick={handleClose}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Cancel
            </div>
          </div>
          <div className='audit-modal-cont-footer-content-btn-upload' onClick={(e) => {
            handleNameChange(e);
          }}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Save
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeTicketName;
